import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Layout from '@/layout';

export const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/index.vue'),
  },
  {
    path: '/',
    redirect: '/home', // 添加根路径的重定向
  },
  {
    path: '/home',
    component: () => import('@/views/home/home.vue'),
    hidden: true,
  },

  {
    path: '/instance',
    component: Layout, // 使用 Layout 作为父级组件
    children: [
      {
        path: 'info',
        component: () => import('@/views/instance/instanceInfo.vue'),
        name: 'instanceInfo',
        meta: {title: '实例详情', activeMenu: '/instance/info'},
      },
    ],
  },

  {
    path: '/device',
    component: Layout,
    meta: {title: '设备管理',},
    hidden: false,
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/product/productListPage.vue'),
        meta: {title: '产品'},
      },
      {
        path: 'productAdd',
        component: () => import('@/views/product/ProductAddPage.vue'),
        name: 'productAdd',
        hidden: true,
        meta: {title: '新建产品', activeMenu: '/device/product'},
      },
      {
        path: 'productInfo',
        component: () => import('@/views/product/productInfoPage.vue'),
        name: 'productInfo',
        hidden: true,
        meta: {title: '查看产品', activeMenu: '/device/product'},
      },
      {
        path: 'importAliyunProduct',
        component: () => import('@/views/product/ImportAliyunProductPage/index.vue'),
        name: 'productInfo',
        hidden: true,
        meta: {title: '导入阿里云产品', activeMenu: '/device/product'},
      },
      {
        path: 'equipment',
        component: () => import('@/views/device/deviceListPage.vue'),
        name: 'equipment',
        meta: {title: '设备'},
      },
      {
        path: 'equipmentDetail',
        component: () => import('@/views/device/deviceInfoPage.vue'),
        name: 'equipmentDetail',
        hidden: true,
        meta: {title: '设备信息', activeMenu: '/device/equipment'},
      },
      {
        path: 'groups',
        component: () => import('@/views/groups/GroupListPage.vue'),
        name: 'groups',
        meta: {title: '分组'},
      },
      {
        path: 'groupInfo',
        component: () => import('@/views/groups/GroupInfoPage.vue'),
        name: 'groupInfo',
        hidden: true,
        meta: {title: '查看产品', activeMenu: '/device/groups'},
      },
      {
        hidden: false,
        path: 'deviceEmulator',
        component: () => import('@/views/device/deviceEmulator.vue'),
        name: 'deviceEmulator',
        meta: {title: '设备模拟器', activeMenu: '/device/deviceEmulator'},
      },
    ],
    alwaysShow: true, // 确保父菜单项始终显示
  },
  {
    path: '/forwarding',
    component: Layout,
    meta: {
      title: '消息转发',
    },
    hidden: false,
    children: [
      {
        path: 'index',
        name: 'forwardingIndex',
        component: () => import('@/views/forwarding/ForwardIndexPage.vue'),
        meta: {title: '服务端订阅'},
      },
      {
        path: 'consumerInfo',
        component: () => import('@/views/forwarding/ForwardConsumerInfoPage.vue'),
        name: 'ForwardConsumerInfoPage',
        hidden: true,
        meta: {title: '消费组', activeMenu: '/forwarding/subscription'},
      },
    ],
    alwaysShow: true, // 确保父菜单项始终显示
  },
  {
    path: '/survey',
    component: Layout,
    meta: {
      title: '监控运维',
    },
    hidden: false,
    children: [
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/log/index'),
        meta: {title: '日志服务'},
      },
      {
        path: 'ota',
        name: 'ota',
        component: () => import('@/views/ota/index.vue'),
        meta: {title: 'OTA 升级'},
      },
      {
        path: 'deviceDebug',
        name: 'deviceDebug',
        component: () => import('@/views/device/deviceDebugPage.vue'),
        meta: {title: '在线调试'},
      },
      {
        path: 'incidentResponse',
        name: 'incidentResponse',
        component: () => import('@/views/incidentResponse/index.vue'),
        meta: {title: '事件响应'},
      },
      {
        path: 'sceneInfo',
        component: () => import('@/views/incidentResponse/SceneInfoPage.vue'),
        name: 'sceneInfo',
        hidden: true,
        meta: {title: '场景详情', activeMenu: '/survey/incidentResponse'},
      },
      {
        path: 'sceneLog',
        component: () => import('@/views/incidentResponse/SceneLogPage.vue'),
        name: 'sceneLog',
        hidden: true,
        meta: {title: '场景日志', activeMenu: '/survey/incidentResponse'},
      },
      {
        path: 'alarm',
        name: 'alarm',
        component: () => import('@/views/alarm/index.vue'),
        meta: {title: '报警配置'},
      },
      {
        path: 'alarmInfo',
        component: () => import('@/views/alarm/AlarmInfoPage.vue'),
        name: 'alarmInfo',
        hidden: true,
        meta: {title: '报警详情', activeMenu: '/survey/alarm'},
      },
      {
        path: 'alarmLog',
        component: () => import('@/views/alarm/AlarmLogPage.vue'),
        name: 'alarmLog',
        hidden: true,
        meta: {title: '报警日志', activeMenu: '/survey/alarm'},
      },
      {
        path: 'noticeLog',
        name: 'noticeLog',
        component: () => import('@/views/noticeLog/index.vue'),
        meta: {title: '消息通知'},
      },
    ],
    alwaysShow: true, // 确保父菜单项始终显示
  },
  {
    path: '/lv',
    component: Layout,
    meta: {
      title: '视频服务',
    },
    hidden: false,
    children: [
      {
        path: 'lvDeviceList',
        name: 'lvDeviceList',
        component: () => import('@/views/lv/lvDeviceListPage.vue'),
        meta: {title: '监控设备'},
      },
      {
        path: 'lvDeviceInfo',
        name: 'lvDeviceInfo',
        component: () => import('@/views/lv/lvDeviceInfoPage.vue'),
        hidden: true,
        meta: {title: '设备详情'},
      },

    ],
    alwaysShow: true, // 确保父菜单项始终显示
  },
  // 价格计算器
  {
    path: '/price',
    name: 'Price',
    component: () => import('@/views/price/index.vue'),
  },

  // -------------------------------- test --------------------------------
  {
    path: '/test/xys/test1',
    name: 'testXysTest1',
    component: () => import('@/views/test/xys/test1.vue'),
  },
  {
    path: '/test/xys/test2',
    name: 'testXysTest2',
    component: () => import('@/views/test/xys/test2.vue'),
  },
  {
    path: '/*',
    name: 'Page404',
    component: () => import('@/views/page404/page404.vue'),
  },
];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location){
  return routerPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: 'hash', // 去掉url中的#
  // base: '/fenydata-web-console',
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes,
});

export default router;
